import { render } from "./SubletDocumentsModal.vue?vue&type=template&id=20d9820e&scoped=true"
import script from "./SubletDocumentsModal.vue?vue&type=script&lang=js"
export * from "./SubletDocumentsModal.vue?vue&type=script&lang=js"

import "./SubletDocumentsModal.vue?vue&type=style&index=0&id=20d9820e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d9820e"]])

export default __exports__